import React, { useState } from "react";
import { Button, message } from "antd";
import { LoadingOutlined } from "@ant-design/icons";

const JLPTLevelList = ["---", "N5", "N4", "N3", "N2", "N1", "暂无日语成绩"];

// 表单组件
const ChineseStudentForm = (props) => {
  const handleSend = props.handleSend;
  const [name, setName] = useState("");
  const [JLPTLevel, setJLPTLevel] = useState("");
  const [university, setUniversity] = useState("");
  const [targetUniversity, setTargetUniversity] = useState("");
  const [contact, setContact] = useState("");
  const [memo, setMemo] = useState("");
  const isSending = props.isSending;

  const handleInputChange = (setter) => (event) => {
    setter(event.target.value);
  };

  // 提交表单
  const handleSubmit = async (event) => {
    event.preventDefault();

    // 必填项检测
    if (
      name === "" ||
      JLPTLevel === "" ||
      university === "" ||
      targetUniversity === "" ||
      contact === "" ||
      memo === ""
    ) {
      console.error("所有必填项都需要填写！");
      message.error("请填写所有必填项。");
      return; // 阻止表单提交
    }

    // 如果填写了邮箱，进行邮箱格式检测
    if (contact.includes("@")) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(contact)) {
        console.error("邮箱格式无效！");
        message.error("请输入有效的邮箱地址。");
        return; // 阻止表单提交
      }
    }

    // 提交表单
    // setIsSending(true);
    console.log({
      name,
      JLPTLevel,
      university,
      targetUniversity,
      contact,
      memo,
    });

    const jsonData = {
      name,
      JLPTLevel,
      university,
      targetUniversity,
      contact,
      memo,
    };
    //pin
    await handleSend(jsonData);
  };

  // 公用样式
  const lightStyles = {
    backgroundColor: "#f1f1f1",
    borderColor: "#cccccc",
    color: "#000000",
  };

  const labelStyle = {
    color: "#000000",
  };

  return (
    <form
      className="form-container"
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        gap: "16px",
      }}
      onSubmit={handleSubmit}
    >
      {/* 姓名 */}
      <div className="input-container" style={{ position: "relative" }}>
        <input
          style={{
            ...lightStyles,
            width: "100%",
            padding: "10px",
            borderRadius: "4px",
          }}
          type="text"
          value={name}
          onChange={handleInputChange(setName)}
          id="name"
          className={`input ${name && "filled"}`}
          placeholder=" "
        />
        <label
          htmlFor="name"
          className={`label ${name && "filled"}`}
          style={{
            ...labelStyle,
            position: "absolute",
            top: name ? "-8px" : "50%",
            left: "10px",
            transform: name ? "translateY(0)" : "translateY(-50%)",
            transition: "all 0.2s",
            backgroundColor: "#f1f1f1",
            padding: "0 4px",
            pointerEvents: "none",
          }}
        >
          姓名
        </label>
      </div>

      {/* JLPT能力 */}
      <div className="input-container" style={{ position: "relative" }}>
        <select
          style={{
            ...lightStyles,
            width: "100%",
            padding: "10px",
            borderRadius: "4px",
            appearance: "none",
          }}
          value={JLPTLevel}
          onChange={(e) => setJLPTLevel(e.target.value)}
          id="JLPTLevel"
          className="input select"
        >
          <option value="" disabled>
            JLPT能力
          </option>
          {JLPTLevelList.map((item) => (
            <option key={item} value={item}>
              {item}
            </option>
          ))}
        </select>
      </div>

      {/* 大学的毕业院校和专业 */}
      <div className="input-container" style={{ position: "relative" }}>
        <input
          style={{
            ...lightStyles,
            width: "100%",
            padding: "10px",
            borderRadius: "4px",
          }}
          type="text"
          value={university}
          onChange={handleInputChange(setUniversity)}
          id="university"
          className={`input ${university && "filled"}`}
          placeholder=" "
        />
        <label
          htmlFor="university"
          className={`label ${university && "filled"}`}
          style={{
            ...labelStyle,
            position: "absolute",
            top: university ? "-8px" : "50%",
            left: "10px",
            transform: university ? "translateY(0)" : "translateY(-50%)",
            transition: "all 0.2s",
            backgroundColor: "#f1f1f1",
            padding: "0 4px",
            pointerEvents: "none",
          }}
        >
          大学毕业院校和专业
        </label>
      </div>

      {/* 目标院校 */}
      <div className="input-container" style={{ position: "relative" }}>
        <input
          style={{
            ...lightStyles,
            width: "100%",
            padding: "10px",
            borderRadius: "4px",
          }}
          type="text"
          value={targetUniversity}
          onChange={handleInputChange(setTargetUniversity)}
          id="targetUniversity"
          className={`input ${targetUniversity && "filled"}`}
          placeholder=" "
        />
        <label
          htmlFor="targetUniversity"
          className={`label ${targetUniversity && "filled"}`}
          style={{
            ...labelStyle,
            position: "absolute",
            top: targetUniversity ? "-8px" : "50%",
            left: "10px",
            transform: targetUniversity ? "translateY(0)" : "translateY(-50%)",
            transition: "all 0.2s",
            backgroundColor: "#f1f1f1",
            padding: "0 4px",
            pointerEvents: "none",
          }}
        >
          目标院校
        </label>
      </div>

      {/* 联系方式 */}
      <div className="input-container" style={{ position: "relative" }}>
        <input
          style={{
            ...lightStyles,
            width: "100%",
            padding: "10px",
            borderRadius: "4px",
          }}
          type="text"
          value={contact}
          onChange={handleInputChange(setContact)}
          id="contact"
          className={`input ${contact && "filled"}`}
          placeholder=" "
        />
        <label
          htmlFor="contact"
          className={`label ${contact && "filled"}`}
          style={{
            ...labelStyle,
            position: "absolute",
            top: contact ? "-8px" : "50%",
            left: "10px",
            transform: contact ? "translateY(0)" : "translateY(-50%)",
            transition: "all 0.2s",
            backgroundColor: "#f1f1f1",
            padding: "0 4px",
            pointerEvents: "none",
          }}
        >
          联系方式（邮箱、微信或Line）
        </label>
      </div>

      {/* 其他咨询细节 */}
      <div className="input-container" style={{ position: "relative" }}>
        <textarea
          style={{
            ...lightStyles,
            width: "100%",
            padding: "10px",
            borderRadius: "4px",
            resize: "vertical",
          }}
          value={memo}
          onChange={handleInputChange(setMemo)}
          id="memo"
          className={`input ${memo && "filled"}`}
          rows={5}
          placeholder=" "
        />
        <label
          htmlFor="memo"
          className={`label ${memo && "filled"}`}
          style={{
            ...labelStyle,
            position: "absolute",
            top: memo ? "-8px" : "10px",
            left: "10px",
            transform: memo ? "translateY(0)" : "translateY(-50%)",
            transition: "all 0.2s",
            backgroundColor: "#f1f1f1",
            padding: "0 4px",
            pointerEvents: "none",
          }}
        >
          其他想要咨询的细节
        </label>
      </div>

      <Button
        className="bg-main-color text-white"
        type="primary"
        style={{
          backgroundColor: "#03B902",
          color: "#ffffff",
          width: "100%",
          height: 50,
          borderRadius: 5,
          fontSize: 18,
          fontWeight: "bold",
        }}
        htmlType="submit"
        disabled={isSending}
        icon={isSending ? <LoadingOutlined /> : null}
      >
        提交
      </Button>
    </form>
  );
};

export default ChineseStudentForm;
